module.exports = __webpack_public_path__ + "static/3A841E_3_0-eb727c7c726c819286515974bb2ab814.svg";